// Local libary
// import { FundingFacade } from '@amwager/funding/data-access';
// import { UnsubscribeObservableService } from '@amwager/util';

// Angular libray
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
// import { AlertController } from '@ionic/angular/standalone';

// Third party
// import { Subscription, takeUntil } from 'rxjs';
// import { forEach } from 'lodash';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'feature-ion-wire-transfer',
  templateUrl: './wire-transfer.component.html',
  styleUrls: ['./wire-transfer.component.scss'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WireTransferComponent implements OnInit {

  wireTransferForm!: FormGroup;

  // convenience getter for easy access to form fields
  get formVal() { return this.wireTransferForm?.controls }

  amount!: number;

  // private subsDepositWireTransferResponse!: Subscription;

  // isDepositing = false;

  // constructor(
  //   private readonly formBuilder: FormBuilder,
  //   private readonly fundingFacade: FundingFacade,
  //   private readonly alertCtrl: AlertController,
  //   private readonly cdRef: ChangeDetectorRef,
  // ) {
  //   super();
  // }

  ngOnInit() {
    // update branch 2
    null;
    // this.initForm();
    // this.formVal['amount']?.setValue(25);
    // this.amount = 25;
  }

  // private initForm(): void {
  //   this.wireTransferForm = this.formBuilder.group({
  //     amount: ['', [Validators.required, Validators.minLength(25), Validators.maxLength(500)]]
  //   });
  // }

  // depositAmount(): void {
  //   this.amount = this.formVal['amount']?.value;
  // }

  // deposit(): void {
  //   if (this.wireTransferForm.valid && this.amount) {
  //     this.isDepositing = true;
  //     this.cdRef.markForCheck();

  //     this.fundingFacade.depositWireTransfer(
  //       this.amount,
  //     );
  //     this.subsDepositWireTransferResponse = this.fundingFacade.isDepositWireTransferSuccess$()
  //     .pipe(takeUntil(this.toUnsubscribe$))
  //     .subscribe(({response, isSuccess}) => {
  //       console.log(response);
  //       console.log(isSuccess);
  //       if (!isSuccess) {
  //         this.showAlertMessage('Error', response.error.Message);
  //       }

  //       this.isDepositing = false;
  //       this.cdRef.markForCheck();

  //       this.subsDepositWireTransferResponse?.unsubscribe();

  //       if (isSuccess) {
  //         this.showAlertMessage('Success', 'Successfully Deposited Amount');
  //       }
  //     });
  //   }
  //   else {
  //     this.markFormGroupTouched(this.wireTransferForm);
  //   }
  // }

  // markFormGroupTouched(formGroup: FormGroup): void {
  //   forEach(formGroup.controls, (control) => {
  //     control.markAsTouched();
  //     if (control instanceof FormGroup) {
  //       this.markFormGroupTouched(control);
  //     }
  //   });
  // }

  // async showAlertMessage(header: string, message: string): Promise<void> {
  //   const alert = await this.alertCtrl.create({
  //     header,
  //     message: message,
  //     buttons: [
  //       {
  //         text: 'Close',
  //         role: 'cancel',
  //         handler: () => {
  //         }
  //       }
  //     ]
  //   });

  //   await alert.present();
  // }

}
